import { InvoiceStatus, InvoiceType } from 'models/EInvoice';

export const INVOICE_STATUS_COLOR_MAP: Record<string, string> = {
  [InvoiceStatus.ISSUED]: 'success',
  [InvoiceStatus.PENDING]: 'warning',
  [InvoiceStatus.DRAFT]: 'processing',
  [InvoiceStatus.CANCELED]: 'error',
  [InvoiceStatus.FAILED]: 'error',
};

export const INVOICE_TYPE_COLOR_MAP: Partial<Record<number, string>> = {
  [InvoiceType.REPLACED]: 'error',
};

export const getInvoiceTagColor = (status: InvoiceStatus | null, invoiceType?: number): string => {
  if (invoiceType !== undefined && INVOICE_TYPE_COLOR_MAP[invoiceType]) {
    return INVOICE_TYPE_COLOR_MAP[invoiceType]!;
  }
  if (status && INVOICE_STATUS_COLOR_MAP[status]) {
    return INVOICE_STATUS_COLOR_MAP[status];
  }
  return 'default';
};

export const isInvoiceError = (status: InvoiceStatus | null, invoiceType?: number): boolean => {
  return status === InvoiceStatus.FAILED || invoiceType === InvoiceType.REPLACED;
};
